import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import api from './utils/http.js'
import loader from '@monaco-editor/loader';

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

loader.config({
    paths: {
        vs: 'https://cdn.bootcdn.net/ajax/libs/monaco-editor/0.43.0/min/vs'
    }
});
window.MonacoEnvironment = {
    getWorkerUrl: function (moduleId, label) {
        return 'https://cdn.bootcdn.net/ajax/libs/monaco-editor/0.43.0/min/vs/base/worker/worker.js';
    }
};

// 初始化应用
const initApp = async () => {
    const app = createApp(App)
    app.config.globalProperties.$api = api;
    app.use(router)
    app.use(store)
    app.use(ElementPlus, {
        locale: zhCn,
    })
    app.use(VXETable)

    // 在挂载前预加载春节配置（带超时控制）
    try {
        await Promise.race([
            store.dispatch('fetchNewYearConfig'),
            new Promise((resolve) => setTimeout(resolve, 3000)) // 3秒超时
        ])
    } catch (error) {
        console.error('预加载春节配置失败:', error)
    }

    app.mount('#app')
}

// 启动应用
initApp()
